import { render, staticRenderFns } from "./DeliverySettings.vue?vue&type=template&id=222174a9&scoped=true&"
import script from "./DeliverySettings.vue?vue&type=script&lang=js&"
export * from "./DeliverySettings.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySettings.vue?vue&type=style&index=0&id=222174a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222174a9",
  null
  
)

export default component.exports